module.exports = __webpack_public_path__ + "img/login-bg.82071c00.png";